import { useEffect } from 'react';

// export function useClickOutside(ref, callback) {
//   useEffect(() => {
//     function handleClickOutside(event) {
//       // Check if the ref exists and if the clicked element is outside of it
//       if (ref.current && !ref.current.contains(event.target)) {
//         callback();
//       }
//     }

//     // Bind the event listener to the document
//     document.addEventListener('mousedown', handleClickOutside);
    
//     // Clean up the listener when the component unmounts or updates
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [ref, callback]);
// }


export function useClickOutside(refsArray, callback) {
  useEffect(() => {
    const handler = (event) => {
      // Check if the click happened inside ANY of the passed refs
      const clickedInside = refsArray.some((ref) => {
        return ref.current && ref.current.contains(event.target);
      });

      // If the click was not inside any ref, trigger the callback
      if (!clickedInside) {
        callback();
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [refsArray, callback]); // Triggers effect if refs array or callback changes
}
